import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Recovered ancient post, implemented with DirectX or RenderMonkey (Offline Shadertoys)`}</p>
    <h1>{`Transmittance of Light`}</h1>
    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "244px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/b70df484e9a6a3b9e2dfdc2075aa0de8/603fe/elephant-deep-peeling.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "97.33333333333333%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAATABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAMEBQb/xAAXAQEBAQEAAAAAAAAAAAAAAAADAQAC/9oADAMBAAIQAxAAAAHTLZxgL06RkrImsOr/AP/EABwQAAICAgMAAAAAAAAAAAAAAAEDAhIAEQQTIf/aAAgBAQABBQJ75CcOX6CJB6hnUbKGlEbFI3z/xAAWEQEBAQAAAAAAAAAAAAAAAAABESD/2gAIAQMBAT8BaOP/xAAXEQEBAQEAAAAAAAAAAAAAAAABABAR/9oACAECAQE/AXoxOf/EABsQAAMAAgMAAAAAAAAAAAAAAAABESExAhAi/9oACAEBAAY/AmlhI9UqG5shxSMmuv/EABoQAQADAQEBAAAAAAAAAAAAAAEAETEhYZH/2gAIAQEAAT8hYLwTi+kMpY5Ebwd8Z8q4WQqBULJorlQAKOE//9oADAMBAAIAAwAAABBQ+MD/xAAXEQEBAQEAAAAAAAAAAAAAAAABABAx/9oACAEDAQE/EFA5IZ//xAAXEQEBAQEAAAAAAAAAAAAAAAABEQAQ/9oACAECAQE/EEiuVBwGXn//xAAcEAEAAwADAQEAAAAAAAAAAAABABEhMUFhcaH/2gAIAQEAAT8Qf+ml5LLB4mqN2fIA49o7l3jRdhwxs4K18l+lC77seGTkYX9H5QEAGAdT/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Figure 1: Elephant Depth Peeling",
            "title": "Figure 1: Elephant Depth Peeling",
            "src": "/static/b70df484e9a6a3b9e2dfdc2075aa0de8/603fe/elephant-deep-peeling.jpg",
            "srcSet": ["/static/b70df484e9a6a3b9e2dfdc2075aa0de8/75985/elephant-deep-peeling.jpg 150w", "/static/b70df484e9a6a3b9e2dfdc2075aa0de8/603fe/elephant-deep-peeling.jpg 244w"],
            "sizes": "(max-width: 244px) 100vw, 244px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Figure 1: Elephant Depth Peeling`}</figcaption>{`
  `}</figure>


    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "102px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/29a9aa5ed70d99af05852e5450f081d3/7d61e/lucy-depth-peeling.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "239.2156862745098%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAwABQDASIAAhEBAxEB/8QAGQAAAwEBAQAAAAAAAAAAAAAAAAQFAgMB/8QAFQEBAQAAAAAAAAAAAAAAAAAAAwL/2gAMAwEAAhADEAAAAbq3PmUNHgtiFCcB0AHTaLKpQ4ZFv//EAB8QAAIBBAIDAAAAAAAAAAAAAAEDAgQREjIhIiMxM//aAAgBAQABBQKV8ae+LNqiUgUSObdqjiCT3Zs8eNQ7M9u+VPu3ZxJChKMmEX//xAAZEQACAwEAAAAAAAAAAAAAAAAQMQECESH/2gAIAQMBAT8B3osxLH//xAAYEQADAQEAAAAAAAAAAAAAAAABAhAiMv/aAAgBAgEBPwEtqP1GGp//xAAeEAACAAYDAAAAAAAAAAAAAAAAAQIQESExYSBxgf/aAAgBAQAGPwJ0yOsklg1ysLoc6QtbuWa9Zk//xAAdEAADAAIDAQEAAAAAAAAAAAAAAREhMUFRcWEQ/9oACAEBAAE/IVZXFgXOXOB3GeBvMZV9kZXLZo8IrFXgihq8LP8ABj7vwFbiaTR4KbRfCiW0FcyGliPHZ//aAAwDAQACAAMAAAAQbMow58//xAAWEQEBAQAAAAAAAAAAAAAAAAABEBH/2gAIAQMBAT8QRkmswKWf/8QAFhEBAQEAAAAAAAAAAAAAAAAAARAR/9oACAECAQE/EACTWYiWf//EAB8QAQACAQQDAQAAAAAAAAAAAAEAESExQWGhUXGxwf/aAAgBAQABPxBlKStAK4cS6eYShHF5Ye3AGio0KswZ0P1iY0YCma1i1zedT9Zd/MYsBdGoUJ1B+wgVYL9XDaHM6H6xwMWgHaY9pbRvVMfhtwHdn//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Figure 1: Lucy Depth Peeling",
            "title": "Figure 1: Lucy Depth Peeling",
            "src": "/static/29a9aa5ed70d99af05852e5450f081d3/7d61e/lucy-depth-peeling.jpg",
            "srcSet": ["/static/29a9aa5ed70d99af05852e5450f081d3/7d61e/lucy-depth-peeling.jpg 102w"],
            "sizes": "(max-width: 102px) 100vw, 102px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Figure 1: Lucy Depth Peeling`}</figcaption>{`
  `}</figure>
    <center></center>
    <p>{`Fig 1 is a very simple implementation in Rendermonkey, using Fresnel item to control the light transmittance. There are many dirty works for packing the float to a rgba texture(I don’t know how to manipulate the depth texture in Rendermonkey!). What’s more, you have to be very careful about the texture coordinates, even there was only 1/2 pixel’s offset.`}</p>
    <h1>{`BTF`}</h1>
    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "244px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/09958ca9b4e35009900a1516a59ee3b7/603fe/btf-teapot.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "93.33333333333333%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAATABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAMEBQL/xAAWAQEBAQAAAAAAAAAAAAAAAAADAQD/2gAMAwEAAhADEAAAAeJonrcOaqFZezWYl//EABsQAAIDAAMAAAAAAAAAAAAAAAECABARAxIT/9oACAEBAAEFAkXZ57GGFDXIR2hJr//EABkRAAEFAAAAAAAAAAAAAAAAAAEAAhARMf/aAAgBAwEBPwFxNoZP/8QAGBEBAQADAAAAAAAAAAAAAAAAAQIAECH/2gAIAQIBAT8BiRMTu//EABYQAAMAAAAAAAAAAAAAAAAAABARIP/aAAgBAQAGPwIK/wD/xAAaEAEBAAMBAQAAAAAAAAAAAAABABEhMRBB/9oACAEBAAE/IR7kfGJXUGoZlNOrA75//9oADAMBAAIAAwAAABCU8AD/xAAYEQEBAAMAAAAAAAAAAAAAAAABABARIf/aAAgBAwEBPxA3E1CyG8f/xAAYEQEBAAMAAAAAAAAAAAAAAAABABARIf/aAAgBAgEBPxDpIhBC6x//xAAaEAEBAQEBAQEAAAAAAAAAAAABEQAhMUFh/9oACAEBAAE/EAK38Mf9JxCb0QMSPrzDOvmfoWEUyeyd0wuOhv/Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Figure 2: BTF",
            "title": "Figure 2: BTF",
            "src": "/static/09958ca9b4e35009900a1516a59ee3b7/603fe/btf-teapot.jpg",
            "srcSet": ["/static/09958ca9b4e35009900a1516a59ee3b7/75985/btf-teapot.jpg 150w", "/static/09958ca9b4e35009900a1516a59ee3b7/603fe/btf-teapot.jpg 244w"],
            "sizes": "(max-width: 244px) 100vw, 244px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Figure 2: BTF`}</figcaption>{`
  `}</figure>
    <p>{`As in Fig 2, it is a very interest way to simulate the SVBRDF, especially useful to simulate the wool or sweater –such kinda rough surface, and the data for rendering is accessible `}<a parentName="p" {...{
        "href": "http://btf.cs.uni-bonn.de/download.html"
      }}>{`here`}</a>{`. You can get these data yourself with your DC. I think it’s sort of image based rendering, a quick implementation stuff can be found `}<a parentName="p" {...{
        "href": "http://http.developer.nvidia.com/GPUGems2/gpugems2_chapter11.html"
      }}>{`here`}</a>{` by Jan Kautz. I use the Matlab to process the image got here. And I interpolate these pictures based on average intensity of pictures.`}</p>
    <h1>{`Classical Lighting`}</h1>
    <p>{`Most of the lighting is computed in an environment with single point light. I read a lot of papers on BRDF, and I just picked up certain light mode to implement. Anisotropic light is even more complex in environment lighting.`}</p>
    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "244px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/a837ddc3d0a8a9c11668a1abaa28754e/603fe/bronze-cook.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "72%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAOABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAIDAQX/xAAWAQEBAQAAAAAAAAAAAAAAAAABAgP/2gAMAwEAAhADEAAAAeZq1cpijP8A/8QAGRABAAMBAQAAAAAAAAAAAAAAAQACEQMQ/9oACAEBAAEFAtWNU8HJbo2J/8QAFxEAAwEAAAAAAAAAAAAAAAAAARARIf/aAAgBAwEBPwESav/EABURAQEAAAAAAAAAAAAAAAAAABAh/9oACAECAQE/Aaf/xAAWEAEBAQAAAAAAAAAAAAAAAAABECD/2gAIAQEABj8CwDP/xAAaEAADAAMBAAAAAAAAAAAAAAAAAREQITFR/9oACAEBAAE/IfQxJWtFvWhnBLiLH//aAAwDAQACAAMAAAAQYw//xAAXEQEAAwAAAAAAAAAAAAAAAAAAESFB/9oACAEDAQE/ELWkv//EABcRAAMBAAAAAAAAAAAAAAAAAAABETH/2gAIAQIBAT8QcNTCH//EABkQAQADAQEAAAAAAAAAAAAAAAEAESExEP/aAAgBAQABPxBxL3msP1kdl6oqzjELpvR0ZiEaK8//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Figure 3: Cook and Torrance [1981]",
            "title": "Figure 3: Cook and Torrance [1981]",
            "src": "/static/a837ddc3d0a8a9c11668a1abaa28754e/603fe/bronze-cook.jpg",
            "srcSet": ["/static/a837ddc3d0a8a9c11668a1abaa28754e/75985/bronze-cook.jpg 150w", "/static/a837ddc3d0a8a9c11668a1abaa28754e/603fe/bronze-cook.jpg 244w"],
            "sizes": "(max-width: 244px) 100vw, 244px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Figure 3: Cook and Torrance [1981]`}</figcaption>{`
  `}</figure>
    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "158px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/3f30c941402abf000c7256449e8f882d/ff44c/lucy-banks.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "154.66666666666666%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAfABQDASIAAhEBAxEB/8QAGQABAAMBAQAAAAAAAAAAAAAAAAIDBAEG/8QAFAEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAAB8/fVrTMBWOJBMP8A/8QAHBAAAgICAwAAAAAAAAAAAAAAAQIAAwQREiMy/9oACAEBAAEFApaFVli+sk9olY2953cInNCwdiEaf//EABURAQEAAAAAAAAAAAAAAAAAABBB/9oACAEDAQE/AaU//8QAFREBAQAAAAAAAAAAAAAAAAAAEEH/2gAIAQIBAT8BhD//xAAbEAACAwADAAAAAAAAAAAAAAAAAQIQESExgf/aAAgBAQAGPwIyPtIkqSHXCNZ0f//EABwQAAICAgMAAAAAAAAAAAAAAAABITERYUFxof/aAAgBAQABPyEnBVuGUPQNUCb2VO3hbqTS2VEbaXGGmYmyYg//2gAMAwEAAgADAAAAECgPDP/EABcRAQEBAQAAAAAAAAAAAAAAAAEQIRH/2gAIAQMBAT8QXBOOp//EABcRAQEBAQAAAAAAAAAAAAAAAAEQIRH/2gAIAQIBAT8QDTOmJ//EAB8QAQACAgICAwAAAAAAAAAAAAEAESExQYFx0VFhkf/aAAgBAQABPxALaNwe9wU7ARI88w2YW1x3ByDC9W9uJv8AMY5ASq6Ayv5Ll6ANnG5v8x4kqpRHuLrq+z3BO+Xye5//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Figure 4: Banks [1994] ",
            "title": "Figure 4: Banks [1994] ",
            "src": "/static/3f30c941402abf000c7256449e8f882d/ff44c/lucy-banks.jpg",
            "srcSet": ["/static/3f30c941402abf000c7256449e8f882d/75985/lucy-banks.jpg 150w", "/static/3f30c941402abf000c7256449e8f882d/ff44c/lucy-banks.jpg 158w"],
            "sizes": "(max-width: 158px) 100vw, 158px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Figure 4: Banks [1994] `}</figcaption>{`
  `}</figure>


    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "141px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/dcba513a1096c12fdbc8fc4e02d0cd21/3a529/lucy-ward.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "173.0496453900709%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAjABQDASIAAhEBAxEB/8QAGgABAAMAAwAAAAAAAAAAAAAAAAEDBAIFBv/EABcBAAMBAAAAAAAAAAAAAAAAAAABAgP/2gAMAwEAAhADEAAAAfP3U9urwBw2ZE6cUqzvgDQA/8QAHRABAAICAgMAAAAAAAAAAAAAAgADATEREwQSM//aAAgBAQABBQKVnCg1CRXWNUfXy1xBqhYDvXvZXrrM6zAccf/EABkRAAEFAAAAAAAAAAAAAAAAAAECEBEgIv/aAAgBAwEBPwFAlgcU/8QAFxEAAwEAAAAAAAAAAAAAAAAAARAgQf/aAAgBAgEBPwErY//EABwQAAEEAwEAAAAAAAAAAAAAAAEAEBExAiFBEv/aAAgBAQAGPwJGXnPlsF4HdlpK01Km/8QAHxABAAIBBAMBAAAAAAAAAAAAAQARITFBcbFRYcHw/9oACAEBAAE/IY1bQFzX5mspdkYEyXM25b1AIHkTvnrrDsVlQK8bxtfqfkw7o3n/2gAMAwEAAgADAAAAEHDOvPPP/8QAGBEBAQEBAQAAAAAAAAAAAAAAARExECD/2gAIAQMBAT8QqrhyCLr4/8QAFxEBAAMAAAAAAAAAAAAAAAAAARARIP/aAAgBAgEBPxBVCYf/xAAhEAEAAgEDBAMAAAAAAAAAAAABABEhMUFhUZHR8KHB4f/aAAgBAQABPxCWvt4RpQocuCAoAVcAS8mpSyq6fMVkAFtG0vWLOFe6Vr941zg+5retCbBrA9L3iyv0uKQn8EEBpXd5npXmHlJyehP/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Figure 4: Ward [1992]",
            "title": "Figure 4: Ward [1992]",
            "src": "/static/dcba513a1096c12fdbc8fc4e02d0cd21/3a529/lucy-ward.jpg",
            "srcSet": ["/static/dcba513a1096c12fdbc8fc4e02d0cd21/3a529/lucy-ward.jpg 141w"],
            "sizes": "(max-width: 141px) 100vw, 141px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Figure 4: Ward [1992]`}</figcaption>{`
  `}</figure>


    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "144px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/ea7be1f0b44f8279a60353385fd3a18d/56357/lucy-gold.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "169.44444444444443%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAiABQDASIAAhEBAxEB/8QAGQABAAMBAQAAAAAAAAAAAAAAAAECBAMF/8QAFgEBAQEAAAAAAAAAAAAAAAAAAgEA/9oADAMBAAIQAxAAAAHw9OfeFzSUi02K5LEb+gWZhN//xAAdEAACAgIDAQAAAAAAAAAAAAABAwIREjEAEyEy/9oACAEBAAEFAuYgKV8gWWX1L11SjNsvF6jPPjEnBesRb/RECv/EABcRAQADAAAAAAAAAAAAAAAAAAEQIEH/2gAIAQMBAT8BCMp//8QAGBEAAgMAAAAAAAAAAAAAAAAAAhEBECD/2gAIAQIBAT8BKaTLH//EAB0QAAEEAgMAAAAAAAAAAAAAAAEAAhARITETUXH/2gAIAQEABj8CVkZkexlBnUW9xtclxoIWtL//xAAcEAACAgMBAQAAAAAAAAAAAAAAARExIVFxYYH/2gAIAQEAAT8hEyyjwWdIBbHgUmL+kekpmPLaS/pKyW29CzUuIUbLen12h4OS9JzC9H//2gAMAwEAAgADAAAAECcjcow//8QAGREAAgMBAAAAAAAAAAAAAAAAAAEQEUEh/9oACAEDAQE/EOTcWlRbGjP/xAAXEQEBAQEAAAAAAAAAAAAAAAABEBEx/9oACAECAQE/EMEJrROQ5P/EAB8QAQACAQQDAQAAAAAAAAAAAAEAESExQVFhcYHwof/aAAgBAQABPxBigsSrpjf9iShTz6IoJlUQFQpcbgTL76EeTfreuIDgAFbdJ8/RLVbQilOyK0K5EvKqXgJiVfAgIoPBzGcJLQrCFo9JwT//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Figure 4: Bastos et al. [1999]",
            "title": "Figure 4: Bastos et al. [1999]",
            "src": "/static/ea7be1f0b44f8279a60353385fd3a18d/56357/lucy-gold.jpg",
            "srcSet": ["/static/ea7be1f0b44f8279a60353385fd3a18d/56357/lucy-gold.jpg 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Figure 4: Bastos et al. [1999]`}</figcaption>{`
  `}</figure>
    <h1>{`References`}</h1>
    <ol>
      <li parentName="ol">{`DC Banks. Illumination in diverse codimensions. pages 327–334. ACM New York, NY, USA, 1994.`}</li>
      <li parentName="ol">{`R Bastos, K Hoff, W Wynn, and A Lastra. Increased photorealism for interactive architectural walkthroughs. pages 183–190. ACM New York, NY, USA, 1999.`}</li>
      <li parentName="ol">{`RL Cook and KE Torrance. A reflectance model for computer graphics. pages 307–316. ACM New York, NY, USA, 1981.`}</li>
      <li parentName="ol">{`GJ Ward. Measuring and modeling anisotropic reflection. pages 265–272. ACM New York, NY, USA, 1992.`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      